import { LoadPanel } from "devextreme-react";
import React from "react";

export const FwAppLoader = React.memo(function GridLoader({ loading }) {
    return (
        <LoadPanel container={'#fw-app'} visible={loading} shadingColor='rgba(0, 0, 0, .3)' message='잠시만 기다려주세요...' className='fw-app-loader' />        
    )
});